// The hand-off packet (Stage 4.5) — the one place the UI talks to its API (server/ai/handoffRoutes.js).
import axiosInstance from "../../../services/axiosInstance";

const unwrap = (p) => p.then(({ data }) => data);

// The call this agent's phone is ringing for, if the assistant handed it over.
export const getCurrentCallHandoff = (callerId) => unwrap(axiosInstance.get("/handoffs/current-call", { params: callerId ? { callerId } : {} }));
// The WhatsApp chats waiting on a person: { handoffs, waiting, open }.
export const getWhatsAppHandoffs = () => unwrap(axiosInstance.get("/handoffs/whatsapp"));
// One packet, with the conversation so far (a call's).
export const getHandoff = (id) => unwrap(axiosInstance.get(`/handoffs/${id}`));
// A call's outcome: one of the business's dispositions and a note.
export const saveHandoffOutcome = (id, { dispositionId = null, note = null }) => unwrap(axiosInstance.post(`/handoffs/${id}/outcome`, { dispositionId, note }));
// A WhatsApp chat handed back to the assistant, with what came of it.
export const handBackChat = (conversationId, { dispositionId = null, note = null } = {}) =>
  unwrap(axiosInstance.post(`/whatsapp/conversations/${conversationId}/handback`, { dispositionId, note }));
export const getDispositions = () => unwrap(axiosInstance.get("/Dispositions"));
// Who is calling, across every channel (the owner's design, 2026-10-26): the ring popup's short briefing and the call panel.
export const getCallerBriefing = (callerId) => unwrap(axiosInstance.get("/calls/briefing", { params: { callerId } }));
